<template>
  <div class="md-layout md-alignment-top-center">

      <md-card v-if="urlJoined === 'true'" class="extra-margin-for-join-message">
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">Anmeldung erfolgreich!</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div class="md-display-1" style="text-align: center">
            <md-icon class="md-size-5x success">sentiment_satisfied_alt</md-icon> <br>
            Vielen Dank, dass du dich der Challenge angeschlossen hast!
          </div>
        </md-card-content>
      </md-card>


    <template v-if="challenge">
      <div class="md-layout-item md-size-70 md-xsmall-size-100">
        <md-tabs md-alignment="fixed">

          <md-tab
            id="tab-home"
            :md-label="$t('challengeOverview.overviewTab')"
            class="maybe-md-card"
          >
            <md-card>
              <md-card-header>
                <div class="public-challenge-title">
                  <i
                    v-if="myDiscipline"
                    :class="[
                      {
                        [formatActitivityIcon(myDiscipline.activityType)]: true,
                      },
                    ]"
                  ></i>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-10 md-xsmall-size-20">
                      <user-avatar :userId="challenge.creatorId" :displayLabels="false" />
                    </div>
                    <div class="md-layout-item">
                      <span class="h2" v-html="challenge.title"></span>
                      <div>
                        <md-icon>calendar_today</md-icon>
                        <!-- <md-icon>schedule</md-icon> -->
                        {{ formatFromToDate(challenge.start, challenge.end) }}<br />
                      </div>
                    </div>
                  </div>
                </div>
              </md-card-header>
              <md-card-content>
                <img :src="challenge.titleImage" alt="Challenge Image" />
                <p v-html="challenge.description"></p>
              </md-card-content>
            </md-card>
          </md-tab>

          <md-tab id="tab-pages" :md-label="(started) ? $t('general.results') : $t('general.participants')" v-if="hasJoined">
            <Leaderboard :challenge="this.challenge" :finished="this.finished" :key="leaderboardKey"/>
          </md-tab>

          <md-tab
            id="tab-organizer"
            :md-label="$t('challengeOverview.organizer')"
            v-if="challenge.organizerInfo"
          >
            <div class="md-layout">
              <div
                class="md-layout-item md-size-30"
                v-if="challenge.organizerInfo.image"
              >
                <img :src="challenge.organizerInfo.image" />
              </div>
              <div
                class="md-layout-item"
                v-html="challenge.organizerInfo.description"
              ></div>
            </div>
          </md-tab>
        </md-tabs>
      </div>

      <div class="md-layout-item md-size-30 md-xsmall-size-100">
        <md-card>
          <md-card-header>
            <days-left
              :start-date="challenge.start"
              :end-date="challenge.end"
            ></days-left>
          </md-card-header>
          <md-card-content>
            <template v-if="hasJoined">
              <md-icon>people</md-icon>
              Derzeitige Teilnehmer: {{ this.challenge.joined.length }}
            </template>
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div
              class="md-layout-item md-size-30 md-medium-size-25"
              v-if="hasInvitation"
            >
              <md-card>
                <md-card-content>
                  <md-button
                    class="md-raised md-success md-layout-item md-size-100"
                    @click="joinInvitation(true)"
                    >Annehmen
                  </md-button>
                  <md-button
                    class="md-raised md-layout-item md-size-100"
                    @click="joinInvitation(false)"
                    >Ablehnen
                  </md-button>
                </md-card-content>
              </md-card>
            </div>
            <div class="md-layout-item md-size-100">
              <template v-if="hasJoined">
                <md-button
                  v-if="showEditButton"
                  class="md-raised md-success md-block"
                  @click="
                    goToRoute(`/challenges/${challenge._id}/edit-registration`)
                  "
                >
                  Meine Anmeldedaten bearbeiten
                </md-button>
                <md-button
                  v-if="canAddManualActivity && started"
                  class="md-raised md-success md-block"
                  @click="goToRoute(`/challenges/${challenge._id}/activity`)"
                  >Manuelle Aktivität hinzufügen
                </md-button>
                <md-button
                  v-if="canBuySomething===true"
                  class="md-raised md-success md-block"
                  @click="goToRoute(`/challenges/${challenge._id}/cart`)"
                  >weitere Produkte kaufen
                </md-button>
              </template>
              <template v-else>
                <md-button
                  class="md-raised md-success md-block"
                  @click="goToRoute(`/challenges/${challenge._id}/cart`)"
                  >Jetzt anmelden
                </md-button>
                <!-- <hr />
                <div>
                  <span class="info">{{$t('challenge.yourCode')}}</span>
                  <input id="code" type="text" v-model="urlCode" placeholder="CODE" />
                  <md-button
                    class="md-raised md-info"
                    @click="goToRoute(`/challenges/${challenge._id}/cart${(urlCode)?'?code='+urlCode:''}`)"
                    >weiter
                  </md-button>
                </div> -->
              </template>
              <template v-if="hasChallengeEnded && resultDocuments && resultDocuments.length">
                <md-button
                  v-for="(document, index) in resultDocuments"
                  :key="index"
                  class="md-simple md-primary md-block"
                  @click="downloadCertificate(document)"
                >{{ document.name }}</md-button>
              </template>

              <md-button
                v-if="isAdmin && this.challenge.joined.length > 0"
                class="md-raised md-info md-block"
                @click="exportResults"
                >export
              </md-button>
            </div>
          </md-card-actions>
        </md-card>
      </div>
    </template>
    <md-progress-spinner v-else md-mode="indeterminate"></md-progress-spinner>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Leaderboard from "@/components/Leaderboard/Leaderboard";
import datetime from "@/utils/datetime";
import activity from "@/utils/activity";
import validation from "@/utils/validation";
import appendUrlParam from "@/utils/appendUrlParam";
import DaysLeft from "sports4me-web_components/atomic-design/atoms/days-left";
import userAvatar from 'sports4me-web_components/atomic-design/atoms/user-avatar.vue'

import { extend } from "vee-validate";
import { max_value, min_value, required } from "vee-validate/dist/rules";
import { Datetime } from "vue-datetime";
// import DragAndDropComponent from '../../atomic-design/molecules/drag-and-drop-component'
import debounce from "@/utils/debounce";

extend("required", required);
extend("min_value", min_value);
extend("max_value", max_value);

export default {
  components: {
    Leaderboard,
    DaysLeft,
    userAvatar,
  },
  data() {
    return {
      id: this.$route.params.id,
      challenge: null,
      // @TODO: refactor to one big object for my RegData
      additionalFormFields: null,
      additionalFormData: null,
      started: false,
      finished: false,
      urlCode:
        this.$route.query["code"] ||
        this.$route.query["join-code"] ||
        this.$route.query["voucher"] ||
        undefined,
      urlPaymentResult: this.$route.query["payment-result"] || undefined, // value: 'success' or 'cancel'
      urlJoined: this.$route.query["joined"],
      urlProcessId: this.$route.query["process-id"],
      joinFormFields: [],
      myData: null,
      resultDocuments: undefined,
      // updatedChallengeRegistration: {},
      components: { lb: null },
      showEditButton: false,
      canBuySomething: false,
      canAddManualActivity: false,
      activity: {
        images: [],
        activityType: null,
        durationInSeconds: null,
        data: {
          distanceInMeters: null,
          averagePaceInMinutesPerKilometer: null,
        },
      },
      showManualActivityDialog: false,
      activityTypes: activity.getActivitiesWithValidData(),
      activityImage: null,
      duration: {
        hours: undefined,
        minutes: undefined,
        seconds: undefined,
      },
      speedInKm: 0,
      minDatetime: null,
      maxDatetime: null,
      distanceInKm: 0,
      showErrorMessage: { duration: true, distance: true },
      leaderboardKey: 0,
      myDiscipline: null,
      myCode: null,
      landingPage: undefined,
      height: "0px",
      doResize: debounce(() => {
        this.stretch = false;
        this.$nextTick(() => {
          if (this.$refs.sliderItems) {
            this.height =
              Math.max(
                ...this.$refs.sliderItems.map(
                  (el) => el.getBoundingClientRect().height
                )
              ) + "px";
          }
          this.stretch = true;
        });
      }, 600),
      stretch: false,
    };
  },
  computed: {
    ...mapState({
      userId: (state) => state.user && state.user._id,
      isAdmin: (state) => state.isAdmin || false,
    }),
    hasJoined() {
      return (
        this.challenge &&
        !!this.challenge.joined.find((u) => u.userId === this.userId)
      );
    },

    hasChallengeEnded() {
      var today = new Date().setHours(0,0,0,0);
      var end = new Date(this.challenge.end).setHours(0,0,0,0);

      return today >= end;
    },
    
    hasInvitation() {
      return (
        this.challenge &&
        !!this.challenge.invited.find((u) => u.userId === this.userId)
      );
    },
  },
  watch: {
    $route(to, from) {
      this.id = to.params.id;
    },
    challenge() {
      if (this.hasJoined) {
        this.loadMyData();
      }
    },
    activity: {
      deep: true,
      handler(v) {
        // this.distanceInKm = formatM2Km(this.activity.data.distanceInMeters);
        this.showErrorMessage.distance =
          !this.activity.data.distanceInMeters > 0;
        this.showErrorMessage.duration = !this.activity.durationInSeconds > 0;

        if (
          this.activity.data.distanceInMeters > 0 &&
          this.activity.durationInSeconds > 0
        ) {
          this.speedInKm = this.calMin4Km(
            this.activity.durationInSeconds,
            this.activity.data.distanceInMeters
          );
        } else {
          this.speedInKm = undefined;
        }
      },
    },
    duration: {
      deep: true,
      handler(val) {
        this.activity.durationInSeconds = this.calculateTimeInSeconds();
      },
    },
    durationInSeconds(val) {
      if (val > 0) {
        this.showErrorMessage.duration = false;
      }
    },
  },
  destroyed() {
    window.removeEventListener("resize", this.doResize);
  },
  created() {
    window.addEventListener("resize", this.doResize);
    this.filterChallengeValues = this.challenge;
  },
  async mounted() {
    this.doResize();

    // remove query params like 'code' and 'join-code' and 'voucher' and 'payment-result'
    if (Object.keys(this.$route.query).length) {
      this.$router.replace(this.$route.path);
    }

    this.loadChallenge();

    if (this.urlPaymentResult === "success") {
      if (this.urlProcessId) {
        let statusResult;
        try {
          statusResult = await this.$api.checkOrderStatus(this.urlProcessId);
        } catch (e) {}
        if (
          !statusResult ||
          !statusResult.orderStatus ||
          statusResult.orderStatus === "submitted"
        ) {
          this.$notify({
            timeout: 0,
            message:
              "Leider ist bei der Verarbeitung der Bestellung ein Fehler aufgetreten. Unser Team wurde verständigt und arbeitet an der Behebung des Problems. Bitte kontaktiere gegebenenfalls unseren Support.",
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          return;
        }
      }
    }

    if (this.urlJoined === "true") {
      this.$notify({
        timeout: 0,
        message:
          "Danke du hast dich erfolgreich zur Challenge angemeldet und erhältst eine Bestätigung per Mail.",
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success",
      });
      window.scrollTo(0, 0);
    } else if (this.urlPaymentResult === "success") {
      this.$notify({
        timeout: 0,
        message:
          "Danke für deine Bestellung, du erhältst eine Bestätigung per Mail.",
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success",
      });
      window.scrollTo(0, 0);
    }
  },
  methods: {
    ...datetime,
    ...activity,
    ...validation,
    // gotToRoute(path) {
    //   this.$router.push("/Challenges/" + this.challenge._id + "/cart");
    // },
    editJoinFrom() {
      this.$router.push(this.challenge._id + "/edit-registration");
    },
    updateTitleImage(data) {
      this.activity.titleImage = data;
    },
    exportResults() {
      this.$store.dispatch("exportResults", this.challenge._id);
    },
    loadChallenge() {
      this.$store
        .dispatch("queryAPI", { url: "/rest/challenge/" + this.id + "?v=1" })
        .then((res) => {
          this.challenge = res;
          this.minDatetime = res.start;
          this.maxDatetime = res.end;
          this.started = new Date() > new Date(res.start);
          this.finished = res.finished ? true : new Date(res.end) < new Date();
          this.canBuySomething = res.merchandise && res.merchandise.length > 0;
        })
        .catch((err) => {
          this.$notify({
            timeout: 5000,
            message: err.message,
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
    loadMyData() {
      if (this.hasJoined) {
        this.$store
          .dispatch("loadMyLeaderboard", {
            challengeId: this.challenge._id,
          })
          .then((res) => {
            if (res.discipline) {
              if (this.challenge && this.challenge.disciplines) {
                this.myDiscipline = this.challenge.disciplines.find(
                  (d) => d.name === res.discipline
                );
                // set default values for manuel activity
                this.activity.activityType = this.myDiscipline.activityType;
                this.activity.title =
                  this.getActivityLabel(this.myDiscipline.activityType) +
                  " für " +
                  this.challenge.title;
              }
            }
            if (res.result) {
              this.myData = res.result;
              this.myData.disciplineName = res.disciplineName;
              // activity
              this.canAddManualActivity =
                res.canAddActivity && !(this.challenge.finished || false); // check if challenge starts already
              // check if user can edit his registration
              this.showEditButton =
                this.challenge &&
                this.challenge.joinForm &&
                this.challenge.joinForm.fields.length &&
                this.myData &&
                !this.myData.time &&
                !this.myData.rank &&
                // && (!this.resultDocuments || (this.resultDocuments && !this.resultDocuments.length))
                this.finished != true;
                if (res.result && res.result.documents && res.result.documents.length > 0) {
                  this.loadDocuments();
                }
            }
            if (res.code) this.myCode = res.code;
            const joinForm = this.challenge.joinForm.fields || [];
            const overrideFields = res.data || [];
            this.additionalFormData = res.additionalFormData || [];
            //empty pre-filled fields we get from the challenge join form
            let emptiedFields = joinForm.map((formField) => {
              let emptiedField = null;
              if (formField.name && formField.value) {
                emptiedField = { ...formField, value: null };
              }
              if (formField.name == "code") {
                emptiedField = { ...formField, disabled: true };
              }
              return emptiedField
                ? { ...formField, ...emptiedField }
                : formField;
            });
            this.joinFormFields = emptiedFields.map((formField) => {
              const overrideField = overrideFields.find(
                (f) => f.name && formField.name === f.name
              );
              return overrideField
                ? { ...formField, ...overrideField }
                : formField;
            });
          });
      }
    },

    loadDocuments() {
      this.$store.dispatch('queryAPI', {
        url: `/rest/challenge/${this.challenge._id}/documents`
      })
      .then(res => {
        console.log("DOC", res);
        this.resultDocuments = res;
      })
      .catch(err => {
        this.resultDocuments = undefined;
      })
    },

    joinInvitation(hasAccepted) {
      if (this.challenge && this.challenge._id) {
        const url = hasAccepted
          ? `/rest/challenge/${this.challenge._id}/joined/me`
          : `/rest/challenge/${this.challenge._id}/reject/me`;

        this.$store
          .dispatch("postAPI", {
            url: url,
            method: "PUT",
            data: null,
          })
          .then((res) => {
            this.$emit("closeMe");
            this.challenge = res;
            if (!hasAccepted) {
              this.$router.push("/Challenges");
            }
            this.$notify({
              timeout: 5000,
              message: "Erfolgreich angemeldet",
              type: "success",
              horizontalAlign: "right",
              verticalAlign: "top",
            });
          })
          .catch((err) => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              type: "error",
              horizontalAlign: "right",
              verticalAlign: "top",
            });
          });
      }
    },
    submitForm() {
      this.$refs.validator.validate();
      this.activity.externalDataSourceId = 40;
      this.activity.images = this.activityImage;
      const body = { url: "/rest/activity/createForMe", data: this.activity };

      this.$refs.validator.validate().then((res) => {
        if (!this.activity.durationInSeconds > 0) {
          this.showErrorMessage.duration = true;
          return;
        }
        if (!this.activity.data.distanceInMeters > 0) {
          this.showErrorMessage.distance = true;
          return;
        }
        if (res) {
          this.$store
            .dispatch("postAPI", {
              url: body.url,
              data: body.data,
            })
            .then((res) => {
              this.loadMyData();
              this.leaderboardKey++;
              this.$notify({
                timeout: 5000,
                message: "Erfogleicht bearbeitet",
                type: "success",
                horizontalAlign: "right",
                verticalAlign: "top",
              });
              this.showManualActivityDialog = false;
            })
            .catch((err) => {
              this.$notify({
                timeout: 5000,
                message: err.message,
                type: "error",
                horizontalAlign: "right",
                verticalAlign: "top",
              });
            });
        }
      });
    },
    calculateTimeInSeconds() {
      const h = (this.duration.hours || 0) * 3600;
      const m = (this.duration.minutes || 0) * 60;
      const s = (this.duration.seconds || 0) * 1;

      return h + m + s;
    },
    onCodeInfoUpdate(data) {
      this.landingPage = data;
      setTimeout(() => {
        this.doResize();
      });
    },
    submit(formData) {
      let data = {
        id: this.id,
        form: formData,
      };
      this.$store
        .dispatch("submitChallengeForm", data)
        .then(() => {
          window.history.replaceState(
            null,
            "",
            appendUrlParam(window.location.href, { joined: "true" })
          );
          window.location.reload();
        })
        .catch((err) => {
          let message = err.message;
          if (err.code === "INVALID_JOIN_CODE") {
            message = "Der angegebene Anmelde-Code ist leider ungültig";
          }
          this.$notify({
            timeout: 5000,
            message,
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },

    downloadCertificate(document) {
      window.open(`${process.env.VUE_APP_BACKEND_URL}/rest/document/${document._id}/data`, "_blank");
    }
  },
};
</script>
<style lang="scss">
@import '~vue-datetime/dist/vue-datetime.css';
.extra-margin-for-join-message {
  margin-bottom: 45px;
}
#code {
  margin: 5px 1px;
  padding: 11px 10px;
}

.joined::before {
  content: "Angemeldet";
  height: 100px;
  width: 300px;
  position: absolute;
  top: 30px;
  right: -60px;
  z-index: 100;
  background: transparent;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  font-size: 4rem;
  text-align: center;
  vertical-align: middle;
  color: red;
  font-family: "Big Shoulders Stencil Text", cursive;
}
.joined.finished::before {
  content: "Beendet";
}
.md-collapse-label .md-collapse-title {
  font-size: 1.5625rem;
  line-height: 1.4em;
}

.md-dialog-actions {
  margin: 8px 16px;
}
.error {
  color: #f4473b !important;
}
.success {
  color: #71bf78 !important;
}
.image {
  display: flex;
  input {
    display: flex;
    align-self: flex-end;
  }
  .image-info {
    display: flex;
    flex-direction: column;
    font-size: 15px;
    align-items: baseline;
  }
}

// .public-challenge-title {
//   display: flex;
//   align-items: center;
//   i {
//     color: #df263b;
//     width: 24px;
//     height: 24px;
//     font-size: 14px;
//     padding: 4px;
//     background: rgba(223, 38, 59, 0.12);
//     margin-right: 12px;
//   }
// }
// .challenge-date-time {
//   display: flex;
//   //height: 100% !important;
//   .vdatetime {
//     flex: 1 1 auto;
//     input {
//       width: 100%;
//       height: 50px !important;
//     }
//   }
// }

.validate-icons {
  position: relative;
  left: calc(100% - 30px);
  top: -40px;
}
.dots {
  display: flex;
  align-items: center;
  &.bold {
    padding: 10px 15px 0 0px;
    font-weight: 400;
    min-width: 130px;
    justify-content: flex-end;
  }
  &.description-info {
    font-size: 14px;
    padding-top: 10px;
  }
  &.fixed-container {
    min-width: 100px;
    font-weight: 400;
  }
}
.md-input {
  width: 100%;
}
.custom-style {
  padding: 0 5px !important;
}

.challenge-date-time {
  padding-right: 0;
  padding-left: 0;
  .md-field:not(.md-disabled):after {
    height: 0;
  }
}

.buttons {
  display: flex;
  justify-content: flex-end;
  padding-top: 40px;
}

.not-allowed-time {
  position: absolute;
  // margin-top: 48px;
  font-size: 12px;
  color: red;
}
// .vueperslides__arrow {
//   font-size: 30px;
//   .vueperslides__arrow--prev {
//     left: -1rem !important;
//   }
//   .vueperslides__arrow--next {
//     right: -1rem !important;
//   }
// }
@media (max-width: 1280px) {
  .image {
    flex-direction: column;
  }
}

@media (max-width: 700px) {
  .challenge-date-time {
    flex-direction: column;
    .dots {
      justify-content: flex-start;
    }
  }
  .challenge-date-time {
    margin: 0 !important;
    //max-height: 46px;
  }
  .manual-activity-modal-container {
    padding: 0 !important;
  }
}
</style>
